import { useMemo } from "react";
import { generatePath, NavLink } from "react-router-dom";

import Card from "~/components/Card";
import LoadingSpinner from "~/components/LoadingSpinners/LoadingSpinner";
import { INVOICE_DETAILS_PATH } from "~/constants/appRoutes.ts";
import { useAllProcessedInvoices } from "~/modules/billing/api/processedInvoice/processedInvoiceQueries.ts";

type Props = { reversedInvoiceId: string; };

const ReversalInvoiceCard = ({ reversedInvoiceId }: Props) => {
	const {
		data: allProcessedInvoicesData,
		isFetching: allProcessedInvoicesIsFetching,
	} = useAllProcessedInvoices();

	const reversalInvoiceData = useMemo(() => {
		if (!allProcessedInvoicesIsFetching && allProcessedInvoicesData) {
			return allProcessedInvoicesData.find(invoice => invoice.reversedInvoiceId === reversedInvoiceId);

		}
		return null;
	}, [allProcessedInvoicesData, allProcessedInvoicesIsFetching, reversedInvoiceId]);

	return <Card title="Storno-Rechnung">
		{reversalInvoiceData &&
			<NavLink className="hover:text-secondary-500" to={generatePath(INVOICE_DETAILS_PATH, { invoiceId: reversalInvoiceData.id })}>{reversalInvoiceData.invoiceNumber}</NavLink>
		}
		{allProcessedInvoicesIsFetching &&
			<div className="flex w-full items-center"><LoadingSpinner scale={0.8} /></div>}

	</Card>;
};

export default ReversalInvoiceCard;